import React from 'react';
import { Button, Dropdown, Menu } from "antd";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./index.css";

export default function NavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menu = (
    <Menu>
      {(location.pathname !== "/search")&& (
        <>
          <Menu.Item key="dayout" onClick={() => navigate('/search?package=dayout')}>
            Day Outs
          </Menu.Item>
          <Menu.Item key="highTea" onClick={() => navigate('/search?package=highTea')}>
            High Tea
          </Menu.Item>
          <Menu.Item key="dining" onClick={() => navigate('/search?package=dining')}>
            Dining
          </Menu.Item>
        </>
      )}
      <Menu.Item key="about">
        <Link to="/about">About</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <nav className="navbar hotel-navbar">
      <div className="navbar-container">
        <div className="logobox">
          <Link to="/">
            {/* <img className="logo" src={"/logo.png"} alt="Logo" /> */}
            <svg className="navbar-logo" viewBox="0 0 665.7 70.902" xmlns="http://www.w3.org/2000/svg">
              <g id="svgGroup" strokeLinecap="round" fillRule="nonzero" fontSize="9pt" stroke="#000" strokeWidth="0.25mm" fill="#000" style={{ stroke: '#000', strokeWidth: '0.25mm', fill: '#000' }}>
                <path d="M 373.5 1.301 L 382.7 1.301 L 382.7 69.301 L 374.7 69.401 L 336.3 16.001 L 336.8 39.701 L 336.8 69.301 L 327.6 69.301 L 327.6 1.301 L 335.6 1.301 L 374 54.801 L 373.5 28.301 L 373.5 1.301 Z M 11.5 62.301 L 54.4 62.301 L 54.4 69.301 L 0 69.301 L 0 64.201 L 42 8.301 L 1.3 8.301 L 1.3 1.301 L 53 1.301 L 53 7.201 L 11.5 62.301 Z M 79.9 62.401 L 112.4 62.401 L 112.4 69.301 L 70.7 69.301 L 70.7 1.301 L 110.4 1.301 L 110.4 8.201 L 79.9 8.201 L 79.9 29.901 L 106.4 29.901 L 106.4 36.801 L 79.9 36.801 L 79.9 62.401 Z M 633.2 62.401 L 665.7 62.401 L 665.7 69.301 L 624 69.301 L 624 1.301 L 663.7 1.301 L 663.7 8.201 L 633.2 8.201 L 633.2 29.901 L 659.7 29.901 L 659.7 36.801 L 633.2 36.801 L 633.2 62.401 Z M 610.2 8.301 L 579.7 8.301 L 579.7 31.701 L 606.2 31.701 L 606.2 38.701 L 579.7 38.701 L 579.7 69.301 L 570.5 69.301 L 570.5 1.301 L 610.2 1.301 L 610.2 8.301 Z M 180.2 1.301 L 155 41.701 L 155 69.301 L 145.8 69.301 L 145.8 41.801 L 120.7 1.301 L 130.8 1.301 L 150.5 34.501 L 170.2 1.301 L 180.2 1.301 Z M 203.1 62.401 L 235.6 62.401 L 235.6 69.301 L 193.9 69.301 L 193.9 1.301 L 203.1 1.301 L 203.1 62.401 Z M 492.2 62.401 L 524.7 62.401 L 524.7 69.301 L 483 69.301 L 483 1.301 L 492.2 1.301 L 492.2 62.401 Z M 268.864 69.959 A 29.849 29.849 0 0 1 259.55 66.151 Q 252 61.401 248.2 53.301 A 40.56 40.56 0 0 1 244.512 38.719 A 48.415 48.415 0 0 1 244.4 35.401 Q 244.4 25.601 248.2 17.551 Q 252 9.501 259.55 4.751 A 30.457 30.457 0 0 1 270.698 0.575 A 41.024 41.024 0 0 1 277.7 0.001 A 39.544 39.544 0 0 1 286.536 0.943 A 29.849 29.849 0 0 1 295.85 4.751 Q 303.4 9.501 307.2 17.551 A 40.144 40.144 0 0 1 310.907 32.31 A 47.652 47.652 0 0 1 311 35.301 A 44.646 44.646 0 0 1 309.589 46.698 A 38.677 38.677 0 0 1 307.2 53.301 Q 303.4 61.401 295.85 66.151 A 30.457 30.457 0 0 1 284.702 70.327 A 41.024 41.024 0 0 1 277.7 70.901 A 39.544 39.544 0 0 1 268.864 69.959 Z M 277.7 63.701 A 26.428 26.428 0 0 0 284.136 62.951 A 20.522 20.522 0 0 0 290.7 60.051 A 22.514 22.514 0 0 0 298.34 51.16 A 27.405 27.405 0 0 0 298.9 49.951 A 33.724 33.724 0 0 0 301.399 40.539 A 42.568 42.568 0 0 0 301.7 35.401 A 40.138 40.138 0 0 0 300.921 27.331 A 32.046 32.046 0 0 0 298.9 20.901 Q 296.1 14.501 290.65 10.801 A 21.337 21.337 0 0 0 281.322 7.332 A 27.585 27.585 0 0 0 277.7 7.101 A 26.108 26.108 0 0 0 271.099 7.9 A 20.661 20.661 0 0 0 264.65 10.801 A 22.975 22.975 0 0 0 256.6 20.454 A 27.515 27.515 0 0 0 256.4 20.901 A 33.175 33.175 0 0 0 253.931 30.033 A 42.244 42.244 0 0 0 253.6 35.401 A 40.305 40.305 0 0 0 254.39 43.541 A 32.518 32.518 0 0 0 256.4 49.951 Q 259.2 56.401 264.65 60.051 A 21.408 21.408 0 0 0 273.486 63.396 A 28.173 28.173 0 0 0 277.7 63.701 Z M 539 69.301 L 539 1.301 L 548.2 1.301 L 548.2 69.301 L 539 69.301 Z M 428.656 68.457 A 7.279 7.279 0 0 1 428.6 68.401 A 6.04 6.04 0 0 1 427.12 66.086 A 6.053 6.053 0 0 1 426.8 64.101 A 5.859 5.859 0 0 1 428.544 59.857 A 7.279 7.279 0 0 1 428.6 59.801 A 6.04 6.04 0 0 1 430.915 58.321 A 6.053 6.053 0 0 1 432.9 58.001 A 5.859 5.859 0 0 1 437.144 59.745 A 7.279 7.279 0 0 1 437.2 59.801 A 6.04 6.04 0 0 1 438.68 62.116 A 6.053 6.053 0 0 1 439 64.101 Q 439 66.601 437.25 68.401 A 5.797 5.797 0 0 1 433.062 70.199 A 7.397 7.397 0 0 1 432.9 70.201 A 5.859 5.859 0 0 1 428.656 68.457 Z" vectorEffect="non-scaling-stroke"/>
              </g>
            </svg>
          </Link>
        </div>
        <div className="button-group">
          {(location.pathname === "/" || location.pathname.startsWith("/p/")) && (
            <Link to="/search">
              <Button size="large" style={{ color: "black" }} type="link">
                Search
              </Button>
            </Link>
          )}
          {location.pathname === "/search" && (
            <Link to="/">
              <Button size="large" style={{ color: "black" }} type="link">
                Home
              </Button>
            </Link>
          )}
          {/* <Button
            size="large"
            style={{ color: "black" }}
            type="link"
            href={'#'}
          >
            Sign Up
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#faa612" }}
            size="large"
          >
            Sign In
          </Button> */}
        </div>
        <div className="button-group-sm">
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="ghost"
              size="large"
              icon={<GiHamburgerMenu color="black" />}
            />
          </Dropdown>
        </div>
      </div>
    </nav>
  );
}